export default __webpack_public_path__ + "static/media/sushi.b3c00882.svg";